import type { ExtendedProgressStatusDto, ProgressStatusListDto, ProgressStatusParams } from './progress-statuses.schema';
import { validateWithZod } from '@/utils/zod.utils';
import { ENDPOINTS } from '../endpoints';
import { httpClient } from '../httpClient';
import { PaginationSchema } from '../types/Pagination.types';
import { ExtendedProgressStatusDtoSchema, ProgressStatusParamsSchema } from './progress-statuses.schema';

export const progressStatusesApi = {
  async getAll(params?: ProgressStatusParams) {
    const validatedParams = params ? validateWithZod(ProgressStatusParamsSchema, params) : undefined;

    const response = await httpClient.get<ProgressStatusListDto>(
      ENDPOINTS.gamification.progressStatuses.all,
      { params: validatedParams },
    );

    return validateWithZod(PaginationSchema(ExtendedProgressStatusDtoSchema), response);
  },

  async getById(id: string) {
    const response = await httpClient.get<ExtendedProgressStatusDto>(ENDPOINTS.gamification.progressStatuses.byId(id));

    return validateWithZod(ExtendedProgressStatusDtoSchema, response);
  },
};
